import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import useRetrieveActiveContractIdAndType from '@/containers/SubscriptionFormPageNew/Layouts/useRetrieveActiveContractIdAndType'
import { PRESTATION_TYPE_CHANGE_TRANSFERRED } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/constants'

export const isLastHolderDataComplete = (lastHolderData: Record<string, any>) =>
  !!(lastHolderData?.last_holder_name && lastHolderData?.last_holder_cf && lastHolderData?.last_holder_property_date)

const useLastHolderValidation = () => {
  const { t } = useTranslation()
  const { country } = useSelector(selectAuthData)
  const { addErrorToContract, removeContractError } = useFormStatus()
  const { id } = useRetrieveActiveContractIdAndType()

  const validateLastHolderData = (lastHolderData: Record<string, any>, prestationType: string) => {
    if (country !== 'it') return
    if (prestationType === PRESTATION_TYPE_CHANGE_TRANSFERRED && !isLastHolderDataComplete(lastHolderData)) {
      addErrorToContract(id, { last_holder_data: t('subscriptionForm:address_module.last_holder_fields.missing_data_error') })
      return
    }
    removeContractError(id, 'last_holder_data')
  }

  return { validateLastHolderData }
}

export default useLastHolderValidation
